/**
 * Given an element, this function traverses the DOM upwards until it finds the overflowSet item container element
 *
 * @param element The base control element
 * @returns The sought parent element if found
 */
export function findParentItemByClass(element: HTMLElement | null, classname: string): HTMLElement | null {
  if (!element) {
    return null;
  }

  if (element.classList?.contains(classname)) {
    return element;
  }
  return findParentItemByClass(element.parentElement, classname);
}
